export const actions = {
  // updateCurrentView: (context, value) => {
  //   context.commit('UPDATE_CURRENT_VIEW', value);
  // },
};

export const mutations = {
  // UPDATE_CURRENT_VIEW: (state, value) => {
  //   state.currentView = value;
  // },
};
